import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { VIDEO_EVENTS, EngineState as ENGINE_STATES } from 'playable/dist/src/constants';
import { get } from 'lodash';
export class PlaybackSuccessLogger extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPlaybackStateChange", _ref => {
      let {
        nextState
      } = _ref;
      switch (nextState) {
        case ENGINE_STATES.PLAY_REQUESTED:
          this._needToLogPlayDone = true;
          this.logPlayRequest();
          break;
        case ENGINE_STATES.PLAYING:
          if (this._needToLogPlayDone) {
            this.logPlayDone();
            this._needToLogPlayDone = false;
          }
          break;
        default:
          break;
      }
    });
    this.subscribeToEvents();
  }
  componentWillUnmount() {
    this.unSubscribeFromEvents();
  }
  subscribeToEvents() {
    const {
      eventEmitter
    } = this.props;
    eventEmitter.on(VIDEO_EVENTS.STATE_CHANGED, this.onPlaybackStateChange);
  }
  unSubscribeFromEvents() {
    const {
      eventEmitter
    } = this.props;
    eventEmitter.off(VIDEO_EVENTS.STATE_CHANGED, this.onPlaybackStateChange);
  }
  logPlayRequest() {
    const {
      videoID,
      channelID,
      engine,
      logTryFunction
    } = this.props;
    const videoUrl = get(engine, 'attachedAdapter.currentUrl', null);
    logTryFunction({
      videoID,
      channelID,
      videoUrl
    });
  }
  logPlayDone() {
    const {
      videoID,
      channelID,
      engine,
      logSuccessFunction
    } = this.props;
    const videoUrl = get(engine, 'attachedAdapter.currentUrl', null);
    logSuccessFunction({
      videoID,
      channelID,
      videoUrl
    });
  }
  render() {
    return null;
  }
}
//# sourceMappingURL=playback-success-logger.js.map